/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { push } from 'react-router-redux';
import SideBar from 'loracoms/SideBar';
import SidebarContainer from 'loracoms/SidebarContainer';
import IntlMsg from 'lorautils/intl/IntlMsg';
import styles from './styles.scss';

const defaultProps = {
  children: null,
};

const propTypes = {
  children: React.PropTypes.any,
  intl: React.PropTypes.any.isRequired,
  pushState: React.PropTypes.func.isRequired,
};

class AccountCenter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      view: 'info',
      detail: {},
    };

    this.intlMsg = new IntlMsg(props.intl, 'accountcenter');
  }

  renderSideBar() {
    const { view } = this.state;
    const { pushState } = this.props;
    return (
      <SideBar
        height={window.innerHeight}
        title={this.intlMsg.msg('title')}
        menuItems={[{
          icon: <i className="glyphicons glyphicons-vcard" />,
          text: this.intlMsg.msg('info'),
          onClick: () => {
            this.setState({ view: 'info' });
            pushState('/accountcenter/info');
          },
          active: view === 'info',
        }, {
          icon: <span className="glyphicons glyphicons-lock" />,
          text: this.intlMsg.msg('security'),
          onClick: () => {
            this.setState({ view: 'security' });
            pushState('/accountcenter/security');
          },
          active: view === 'security',
        }, {
          icon: <span className="glyphicons glyphicons-keys" />,
          text: this.intlMsg.msg('tokenmanagement'),
          onClick: () => {
            this.setState({ view: 'management' });
            pushState('/accountcenter/token');
          },
          active: view === 'management',
        }]}
      />
    );
  }

  render() {
    return (
      <div>
        {this.renderSideBar()}
        <SidebarContainer>
          <div className={styles.view}>
            {this.props.children}
          </div>
        </SidebarContainer>
      </div>
    );
  }
}

AccountCenter.propTypes = propTypes;
AccountCenter.defaultProps = defaultProps;

const mapDisPatchToProps = {
  pushState: push,
};

export default connect(null, mapDisPatchToProps)(injectIntl(AccountCenter));




// WEBPACK FOOTER //
// ./src/containers/AccountCenter/index.jsx